import React from 'react';
import {flushSync} from "react-dom";

import {CardContent, Card, CircularProgress, Typography, Stack, LinearProgress, Snackbar} from "@mui/joy";
import Chip from "@mui/joy/Chip";

// components
import BaseApi from "../../utils/BaseApi";
import CommonForm from "../Common/CommonForm";
import {isObjectEmpty} from "../../utils/misc";

// icons
import WarningIcon from '@mui/icons-material/Warning';
import SaveIcon from '@mui/icons-material/Save';
import UserContext from "../../context/UserContext";


class Checklist extends React.Component {
    static contextType = UserContext

    constructor(props) {
        super(props);
        this.state = {
            checklist: null,
            formFields: null,
            answersCount: 0,
            saved: true,
            snackbarOpen: false,
            snackbarText: '',
        };
    }

    async componentDidMount() {
        await this.retrieveChecklist();
    }

    countAnswers(formData){
        let answersCount = 0;
        for (let field of Object.entries(formData)){
            if (field[1] !== undefined && field[1] !== ''){
                answersCount += 1
            }
        }
        return answersCount
    }

    async retrieveChecklist(){
        const url = `checklist/${this.props.checklist.id}/`;
        const api = new BaseApi();
        let answersCount = 0;
        let response = await api.get(url, {});
        let formFields = await this.retrieveFormFields(response.data);
        let checklist = response.data
        if (typeof checklist.data !== 'object'){
            checklist.data = JSON.parse(checklist.data)
        }
        for (let field of formFields){
            if (field.type === 'checkbox'){
                answersCount += 1
                checklist.data[field.name] = checklist.data[field.name] === 'true'
            }
        }
        if (!isObjectEmpty(checklist.data)){
            answersCount = this.countAnswers(checklist.data)
        }
        this.setState(
            {
                checklist: checklist,
                answersCount: answersCount,
                formFields: formFields,
                saved: true,
            }
        );
    }

    async retrieveFormFields(checklist){
        const url = `checklist/${checklist.id}/update_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        return response.data
    }

    async processForm(form){
        const url = `checklist/${this.state.checklist.id}/`;
        const api = new BaseApi();
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        let response = await api.patch(
            url,
            {
                data: JSON.stringify(formDataObj)
            }
        );
        if (response.status === 200){
            this.snackbarCallback(true, `Сохранено!`)
            this.setState({
                saved: true,
            })
        }
        return response
    }

    onChecklistChange(event){
        flushSync(() => {})
        let formData = new FormData(
            event.target.form
        );
        let answersCount = this.countAnswers(Object.fromEntries(formData))
        this.setState({
            answersCount: answersCount,
            saved: false,
        })
    }

    snackbarCallback(open, text){
        this.setState(
            {
                snackbarOpen: open,
                snackbarText: text,
            }
        );
    }

    render() {
        if (!this.state.checklist || !this.state.formFields) {
            return (<CircularProgress/>)
        }
        let fieldsCount = this.state.formFields.length
        if (this.state.checklist.public_owner === this.context.userObject?.id && !this.state.checklist.completed){
            fieldsCount -= 1
        }
        return(
            <>
                <Card
                    variant={'plain'}
                    size={'sm'}
                >
                    <CardContent>
                        <Stack
                            direction={'row'}
                            spacing={2}
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                                pb: 2
                            }}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                                sx={{
                                    minWidth: '50%'
                                }}
                            >
                                <Typography
                                    level={'h4'}
                                >
                                    {this.state.checklist.type.title}
                                </Typography>
                                {
                                    this.state.saved?
                                        <Chip
                                            color={'success'}
                                            sx={{
                                                mr: 1
                                            }}
                                            startDecorator={<SaveIcon fontSize={'small'}/>}
                                        >
                                            Сохранен
                                        </Chip>:
                                        <Chip
                                            color={'warning'}
                                            sx={{
                                                mr: 1
                                            }}
                                            startDecorator={<WarningIcon fontSize={'small'}/>}
                                        >
                                            Не сохранен
                                        </Chip>
                                }
                            </Stack>
                            <Stack
                                direction={'row'}
                                spacing={1}
                                sx={{
                                    flexGrow: 2,
                                    flexWrap: 'wrap',
                                    alignItems: "center",
                                }}
                                useFlexGap
                            >
                                <LinearProgress
                                    size="md"
                                    color={this.state.answersCount===fieldsCount?'success':'warning'}
                                    determinate
                                    value={this.state.answersCount / fieldsCount * 100}
                                />
                                <Typography>
                                    {this.state.answersCount} / {fieldsCount}
                                </Typography>
                            </Stack>
                        </Stack>
                        <CommonForm
                            fields={this.state.formFields}
                            object={this.state.checklist.data}
                            processForm={this.processForm.bind(this)}
                            onChange={this.onChecklistChange.bind(this)}
                        />
                    </CardContent>

                </Card>
                <Snackbar
                    anchorOrigin={{
                        'vertical': 'bottom',
                        'horizontal': 'center'
                    }}
                    sx={{
                        zIndex: 1010,
                        position: 'fixed',
                    }}
                    open={this.state.snackbarOpen}
                    key={'Snackbar' + this.state.checklist.id}
                    onClose={() => {
                        this.snackbarCallback(false, '')
                    }}
                >
                    {this.state.snackbarText}
                </Snackbar>
            </>
        )
    }
}

export default Checklist